import React, { useEffect, useCallback, useRef } from 'react'
import {
    isTabletDevice,
    submitEkyc,
    setReturnFileOrFaceDefault,
    sendPostMessageFakeOcr,
    closeThis,
    sendPostMessageClose,
    sendPostMessageOcrFail,
    sendPostMessageResult,
    sendPostMessageMaxCount,
} from './common'
import { useCOMTRUECameraEtc } from '../camera/cameraEtc'
import { createCOMTRUEEncryptUtils } from '../encrypt/encryptUtil'
import { COMTRUEVAR } from './ocr_variables'
import { useComtrueCamera } from '../camera/camera'
import { uploadImageByBlob } from '../callbackSample/callback'

export var useCOMTRUEOcrCommon = () => {
    const ComtrueCamera = useComtrueCamera()
    const COMTRUECameraEtc = useCOMTRUECameraEtc()

    // 암호화 함수 호출관련 추가
    const COMTRUEEncryptUtils = createCOMTRUEEncryptUtils()

    const resizeCardFrame = useCallback((cardType) => {
        let screenWidth = window.screen.width
        let screenHeight = window.innerHeight

        if (isTabletDevice()) {
            screenWidth *= 0.9
        } else {
            if (screenWidth > 400) {
                screenWidth = 400
            }
        }

        let margin
        let width
        let height
        let guideGridBottomRatio = 1

        switch (cardType) {
            case 'kpassport':
            case 'passport':
                margin = 20
                width = screenWidth - margin * 2
                height = (width * 86) / 124
                break
            case 'usim_small':
                margin = 20
                width = screenWidth - margin * 2
                height = (width * 13) / 15
                break
            case 'imei':
                margin = 30
                width = screenWidth - margin * 2
                height = (width * 26) / 22

                const boxTopElements = COMTRUEVAR.boxTopRefComtrue
                Array.from(boxTopElements).forEach((element) => {
                    element.style.paddingBottom = '13px'
                })
                break
            default:
                margin = 22
                width = screenWidth - margin * 2
                height = (width * 54) / 86
                break
        }

        if (width + margin * 2 > screenWidth) {
            let ratio = width / screenWidth
            width = width / ratio
            height = height / ratio
        }

        const boxContainer = COMTRUEVAR.boxContainerRefComtrue
        if (boxContainer) {
            boxContainer.style.gridTemplateRows = `${COMTRUEVAR.BOX_CONTAINER_ROWS_TOP_RATIO}fr ${height}px ${guideGridBottomRatio}fr`
            boxContainer.style.gridTemplateColumns = `${COMTRUEVAR.BOX_CONTAINER_COLUMNS_TOP_RATIO}fr ${width}px ${COMTRUEVAR.BOX_CONTAINER_COLUMNS_BOTTOM_RATIO}fr`
        }

        const rectangleCursor = COMTRUEVAR.rectangleCursorRefComtrue
        if (rectangleCursor) {
            rectangleCursor.height = height + 4 + 'px'
            rectangleCursor.width = width + 4 + 'px'
        }

        const resultFormGroup = COMTRUEVAR.resultFormGroupRefComtrue
        if (resultFormGroup) {
            resultFormGroup.style.maxHeight = screenHeight - 222 + 'px'
        }

        const modalContent = COMTRUEVAR.modalContentRefComtrue
        if (modalContent) {
            modalContent.style.maxHeight = screenHeight - 55 + 'px'
        }
    }, [])

    const videoResize = useCallback(() => {
        // 비디오 리사이즈 로직
    }, [])

    const removeAllChild = useCallback((div) => {
        if (div) {
            while (div.hasChildNodes()) {
                div.removeChild(div.firstChild)
            }
        }
    }, [])

    const createFakeMessage = useCallback((targetDiv, newDivId) => {
        if (targetDiv) {
            const fakeMessage = document.createElement('div')
            fakeMessage.setAttribute('id', newDivId)
            targetDiv.append(fakeMessage)
        }
    }, [])

    const checkBlob = useCallback((blob) => {
        return blob != null && blob.size > 10000
    }, [])

    // fixme [2025.06.09] 미사용 주석처리
    /*const submitEdit = useCallback(() => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[submitEdit] START');
        }

        let validation = COMTRUEOcrModal.inputValidationCheck();
        if (!validation) {
            return;
        }

        // fixme [2025.06.09] 미사용 주석처리
        // COMTRUECommon.modalButtonDisabled();

        let modified = "";
        if (COMTRUEVAR.getModifiedText === "false") {
            sendEdit(modified);
        } else {
            modified = COMTRUEOcrModal.modifiedValueEdit();
            if (COMTRUEVAR.encryptView) {
                const uint8Array = new TextEncoder().encode(JSON.stringify(modified));
                if (uint8Array.length > 190) {
                    COMTRUEEncryptUtils.encryptSplitTextWithPublicKey(uint8Array)
                        .then((result) => {
                            if (COMTRUEVAR.debugModeComtrue) {
                                console.log(result);
                            }
                            sendEdit(result);
                        });
                } else {
                    COMTRUEEncryptUtils.encryptTextWithPublicKey(uint8Array)
                        .then((result) => {
                            if (COMTRUEVAR.debugModeComtrue) {
                                console.log(result);
                            }
                            sendEdit(result);
                        });
                }
            } else {
                sendEdit(JSON.stringify(modified));
            }
        }
    }, []);*/

    const sendEdit = useCallback((modified) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[sendEdit] START')
        }
        const fields = JSON.stringify(COMTRUEVAR.excludeOcrFields)
            .replaceAll('"', '')
            .replaceAll('[', '')
            .replaceAll(']', '')
        fetch(`${COMTRUEVAR.contextPathComtrue}/api/v3/edit`, {
            method: 'PATCH',
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: COMTRUEVAR.tokenComtrue,
                modified: modified,
                excludeOcrFields: JSON.stringify(fields),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 0) {
                    submitEkyc(
                        COMTRUEVAR.ekycModeComtrue,
                        COMTRUEVAR.tokenComtrue
                    )
                } else {
                    alert(
                        '[E]정보 제출에 실패하였습니다. status:' + data.status
                    )
                    // fixme [2025.06.09] 미사용 주석처리
                    // pageReload();
                }
            })
            .catch((error) => {
                alert('[E]정보 제출에 실패하였습니다. error:' + error)
                // fixme [2025.06.09] 미사용 주석처리
                // pageReload();
            })
    }, [])

    const cameraStart = useCallback((cardType) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[cameraStart] START')
        }
        // const targetId = 'bottom_text';
        removeAllChild(COMTRUEVAR.bottomTextRefComtrue)
        createFakeMessage(COMTRUEVAR.bottomTextRefComtrue, 'fake_message')
        // fixme [2025.06.09] 미사용 주석처리
        // COMTRUECommon.setCameraBtn();
        // [25.07.02] 초기 촬영 딜레이 추가
        setTimeout(() => {
            capture(cardType)
        }, COMTRUEVAR.OCR_INIT_DELAY)
    }, [])

    const blob2 = null

    const uint8ArrayToBase64 = useCallback((uint8Array) => {
        let binary = ''
        const len = uint8Array.byteLength
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(uint8Array[i])
        }
        return window.btoa(binary)
    }, [])

    const base64ToUint8Array = useCallback((base64) => {
        const binary_string = window.atob(base64)
        const len = binary_string.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i)
        }
        return bytes
    }, [])

    const capture = useCallback(async (cardType, callbackFunc) => {
        const stor_callback = localStorage.getItem('comtrue_callback')

        if (callbackFunc === undefined || callbackFunc == null) {
            callbackFunc = COMTRUEVAR.CALL_BACK_FUNC
        }
        if (typeof callbackFunc === 'string') {
            callbackFunc = window[callbackFunc]
        }

        if (
            typeof COMTRUEVAR.checkVisibilityState !== 'undefined' &&
            COMTRUEVAR.checkVisibilityState === 'hidden'
        ) {
            COMTRUEVAR.checkVisibilityStateVisible = false
            COMTRUEVAR.cardTypeVarComtrue = cardType
            return
        }

        setReturnFileOrFaceDefault(cardType)

        var uint8Array = null
        var blob = null
        //////////////////////////////////////////////////////////// [2025.06.10] pttJPEG로 변환
        // const getDataUrl2 = COMTRUECameraEtc.getCaptureCanvasSize(cardType, COMTRUEVAR.videoComtrue, COMTRUEVAR.canvasComtrue);
        //
        // const blobBin = window.atob(getDataUrl2.split(',')[1]);
        // const array1 = [];
        // for (let i = 0; i < blobBin.length; i++) {
        //     array1.push(blobBin.charCodeAt(i));
        // }
        // const uint8Array = new Uint8Array(array1);
        //
        // const getDataUrl = COMTRUECameraEtc.getCaptureCanvasSize(cardType, COMTRUEVAR.videoComtrue, COMTRUEVAR.canvasComtrue);
        // const imageString = getDataUrl.split(",")[1];

        // var sendData = imageString;
        ////////////////////////////////////////////////////////////
        COMTRUECameraEtc.getCaptureCanvasSize(
            cardType,
            COMTRUEVAR.videoComtrue,
            COMTRUEVAR.canvasComtrue
        )
            .then(async (array1) => {
                uint8Array = new Uint8Array(array1)

                let canvasWidth = COMTRUEVAR.canvasComtrue.width
                let canvasHeight = COMTRUEVAR.canvasComtrue.height

                try {
                    COMTRUEVAR.canvasComtrue
                        .getContext('2d')
                        .clearRect(0, 0, canvasWidth, canvasHeight)
                    COMTRUEVAR.canvasComtrue.getContext('2d').beginPath()
                } catch (e) {
                    console.log('canvas.getContext.clearRect ERROR: ' + e)
                }

                array1 = null

                if (COMTRUEVAR.debugModeComtrue) {
                    console.log(
                        'COMTRUEVAR.encryptView: ',
                        COMTRUEVAR.encryptView
                    )
                }

                // [2025.06.16] encryptView 조건 변경, 자바스크립트에서 string 으로 들어오는 경우가 있음
                if (
                    COMTRUEVAR.encryptView === true ||
                    COMTRUEVAR.encryptView === 'true'
                ) {
                    if (
                        COMTRUEVAR.requestEncryptPublicKeyComtrue == null ||
                        COMTRUEVAR.responseDecryptPrivateKeyComtrue == null
                    ) {
                        COMTRUEEncryptUtils.importRsaKeys()
                        return
                    } else {
                        // const uint8Array = base64ToUint8Array(sendData);

                        const video = COMTRUEVAR.videoComtrue

                        // [2025.06.16] 변수를 복사해 두는 이유 : setTimeout은 비동기라서 아래 uint8Array = null;로 초기화되는 코드가 먼저 실행될 수 있음
                        let copyOfUint8Array = uint8Array

                        setTimeout(() => {
                            // encryptUtils 에서 capture 를 호출하지 않도록 try~catch 이동
                            try {
                                COMTRUEEncryptUtils.encryptDataWithPublicKey(
                                    copyOfUint8Array,
                                    cardType
                                )
                                    .then(async (result) => {
                                        blob = new Blob([result])

                                        const base64String =
                                            uint8ArrayToBase64(result)
                                        COMTRUEVAR.ocrLiveness = true

                                        let sendImage
                                        if (
                                            stor_callback === 'call_IdSend_blob'
                                        ) {
                                            sendImage = blob
                                        } else {
                                            sendImage = base64String
                                        }

                                        await uploadImageByBlob({
                                            blob,
                                            cardType,
                                            token: COMTRUEVAR.tokenComtrue,
                                            returnFile:
                                                COMTRUEVAR.returnFileVarComtrue,
                                            returnFace:
                                                COMTRUEVAR.returnFaceVarComtrue,
                                            encryptView: COMTRUEVAR.encryptView,
                                            liveness: COMTRUEVAR.ocrLiveness,
                                            rsaKeys: JSON.stringify(
                                                COMTRUEVAR.rsaKeys
                                            ),
                                            initTime: COMTRUEVAR.initTime,
                                            sendData: sendImage,
                                            // [2025.06.16] uploadResult -> data로 바꿈 ; 함수명과 변수가 중복되어 있었음.
                                            afterUploadCallback: (data) => {
                                                console.log(
                                                    'OCR 결과 처리 시작:',
                                                    data
                                                )
                                                uploadResult(
                                                    data,
                                                    COMTRUEVAR.useWebSocket,
                                                    cardType
                                                )
                                            },
                                        })

                                        /* callbackFunc(sendImage, cardType, COMTRUEVAR.tokenComtrue, COMTRUEVAR.returnFileVarComtrue, COMTRUEVAR.returnFaceVarComtrue, COMTRUEVAR.encryptView, COMTRUEVAR.ocrLiveness, function (uploadResult) {
                                             console.log("OCR 결과 처리 시작:", uploadResult);
                                             console.log("[capture] 3 | video.paused ? ", video?.paused);
                                             uploadResult(uploadResult, COMTRUEVAR.useWebSocket, cardType);
                                             console.log("[capture] 4 | video.paused ? ", video?.paused);
                                         });*/

                                        // [2025.06.16] 민감 데이터 초기화
                                        uint8Array = null
                                        blob = null
                                        copyOfUint8Array = null
                                        canvasWidth = null
                                        canvasHeight = null
                                    })
                                    .catch((err) => {
                                        console.log(err)
                                        setTimeout(() => {
                                            capture(cardType, callbackFunc)
                                        }, 2222)
                                    })
                            } catch (err) {
                                setTimeout(() => {
                                    capture(cardType)
                                }, 1500)
                            }
                        }, 500)
                    }
                } else {
                    blob = new Blob([uint8Array])

                    if (!checkBlob(blob)) {
                        // jejeong [2025-06-10] 금보원 취약점 조치 :: 메모리 노출
                        uint8Array = null
                        blob = null
                        canvasWidth = null
                        canvasHeight = null

                        setTimeout(() => {
                            capture(cardType, callbackFunc)
                        }, 300)
                        return
                    }

                    // COMTRUEVAR.ocrLiveness = true;

                    await uploadImageByBlob({
                        blob,
                        cardType,
                        token: COMTRUEVAR.tokenComtrue,
                        returnFile: COMTRUEVAR.returnFileVarComtrue,
                        returnFace: COMTRUEVAR.returnFaceVarComtrue,
                        encryptView: COMTRUEVAR.encryptView,
                        liveness: COMTRUEVAR.ocrLiveness,
                        afterUploadCallback: (data) => {
                            console.log('OCR 결과 처리 시작:', data)
                            uploadResult(
                                data,
                                COMTRUEVAR.useWebSocket,
                                cardType
                            )
                        },
                    })
                    /* call_IdSend(sendData, cardType, COMTRUEVAR.tokenComtrue, COMTRUEVAR.returnFileVarComtrue, COMTRUEVAR.returnFaceVarComtrue, COMTRUEVAR.encryptView, COMTRUEVAR.ocrLiveness, function (uploadResult) {
                         console.log("OCR 결과 처리 시작:", uploadResult);
                         uploadResult(uploadResult, COMTRUEVAR.useWebSocket, cardType);
                     });*/
                }

                // jejeong [2025-06-12] 금보원 취약점 조치 :: 메모리 노출
                uint8Array = null
                blob = null
                canvasWidth = null
                canvasHeight = null
            })
            .catch(function (error) {
                console.log('getCaptureCanvasSize ERROR: ' + error)
                setTimeout(() => {
                    // hjkim [2024-05-18] 자동/수동 모드에 따라 촬영방식 설정
                    // if (COMTRUEVAR.manual_mode) {
                    //     COMTRUECommon.setCameraBtn();
                    // } else {
                    capture(cardType)
                    // }
                }, 2222)
            })
    }, [])

    const call_IdSend = (
        sendData,
        cardType,
        token,
        returnFile,
        returnFAce,
        encryptView,
        ocrLiveness,
        callBackFunc
    ) => {
        console.log('call_IdSend()!!')
    }

    const uploadResult = useCallback(
        (result, useWebSocketComtrue, cardType) => {
            // [25.07.02] 인터벌 추가
            COMTRUEVAR.ocrCaptureCount++
            if (COMTRUEVAR.ocrCaptureCount > COMTRUEVAR.OCR_MAX_CNT) {
                if (COMTRUEVAR.debugModeComtrue) {
                    console.log(
                        '[capture] Max captrue count reached. COMTRUEVAR.ocrCaptureCount : ' +
                            COMTRUEVAR.ocrCaptureCount
                    )
                }
                sendPostMessageMaxCount()
                // closeThis('최대 촬영 횟수에 도달했습니다.')
                closeThis(
                    '유효한 촬영시간이 지났습니다.<br/>신분증 촬영을 다시 시도해주세요.'
                )
            }
            const video = COMTRUEVAR.videoComtrue
            console.log('[uploadResult] 1 | video.paused ? ', video?.paused)
            console.log('[uploadResult] data: ', result)
            console.log('[uploadResult] typeof result : ', typeof result)
            const data =
                typeof result === 'string' ? JSON.parse(result) : result

            console.log('[uploadResult] data: ', data)

            COMTRUEVAR.errorCount = 0

            if (COMTRUEVAR.rectangleEdgeRefsComtrue) {
                editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'active', false)
                editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'warning', false)
                editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'iffy', false)
            }

            if (COMTRUEVAR.fakeCount > COMTRUEVAR.CLOSE_FAKE_CNT_COMTRUE) {
                const message = getKorCardTypeMessage(cardType)
                saveCacheImage(blob2)
                sendPostMessageFakeOcr()
                closeThis(message)
                waringTextSettings2('')
                return
            }

            // [2025.06.10] 응답 값 변수값 저장 추가
            if (data && 'result' in data) {
                COMTRUEVAR.resData = data.result
            }
            if (data && 'capture_count' in data) {
                COMTRUEVAR.captureCount = data.captureCount
            }
            if (data && 'blur_score' in data) {
                COMTRUEVAR.blurScore = data.blurScore
            }

            if (data.status === 0) {
                COMTRUEVAR.fakeCount = 0
                COMTRUEVAR.blurCount = 0

                editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'active', true)

                const comment2Elements = COMTRUEVAR.comment2RefsComtrue
                Array.from(comment2Elements).forEach((element) =>
                    element.remove()
                )

                console.log('!!!! data : ' + JSON.stringify(data))

                // [2025.06.10] postMesage 누락 추가 및 함수 오류 수정
                sendPostMessageResult(data)
                closeThis('', '0', ComtrueCamera.stopCameraStream)
                waringTextSettings2('')
                return
            } else if (data.status === -5) {
                // [2025.07.10] onnx_response -> onnxResponse 수정
                if ('onnxResponse' in data) {
                    // [2025.06.10] liveness 안에서 real 을 꺼내 확인하는 부분 추가
                    // [2025.06.13] 타입 확인 후 json parse 추가
                    if ('liveness' in data.onnxResponse) {
                        try {
                            if (
                                typeof data.onnxResponse.liveness === 'string'
                            ) {
                                data.onnxResponse.liveness = JSON.parse(
                                    data.onnxResponse.liveness
                                )
                            }
                            if ('real' in data.onnxResponse.liveness) {
                                if (
                                    data.onnxResponse.liveness.real ===
                                        'false' ||
                                    data.onnxResponse.liveness.real === 'F'
                                ) {
                                    COMTRUEVAR.realCount = 0
                                    COMTRUEVAR.fakeCount++
                                    if (
                                        COMTRUEVAR.fakeCount >
                                        COMTRUEVAR.MAX_FAKE_CNT_COMTRUE
                                    ) {
                                        editClass(
                                            COMTRUEVAR.rectangleEdgeRefsComtrue,
                                            'warning',
                                            true
                                        )
                                        // cardTypeFakeMessage(cardType)
                                        //사본
                                        waringTextSettings2('fakeCard')
                                    }
                                }
                            }
                        } catch (e) {
                            console.log(
                                'data.onnxResponse.liveness error: ' + e
                            )
                        }
                    }
                    if ('real' in data.onnxResponse) {
                        if (data.onnxResponse.real === 'false') {
                            COMTRUEVAR.realCount = 0
                            COMTRUEVAR.fakeCount++
                            if (
                                COMTRUEVAR.fakeCount >
                                COMTRUEVAR.MAX_FAKE_CNT_COMTRUE
                            ) {
                                editClass(
                                    COMTRUEVAR.rectangleEdgeRefsComtrue,
                                    'warning',
                                    true
                                )
                                // cardTypeFakeMessage(cardType)
                                waringTextSettings2('fakeCard')
                            }
                        }
                    }
                    if ('message' in data.onnxResponse) {
                        if (data.onnxResponse.message.includes('Image blur')) {
                            if (COMTRUEVAR.ocrLiveness === true) {
                                COMTRUEVAR.realCount = 0
                                COMTRUEVAR.blurCount++
                                if (
                                    COMTRUEVAR.blurCount >
                                    COMTRUEVAR.MAX_BLUR_CNT_COMTRUE
                                ) {
                                    editClass(
                                        COMTRUEVAR.rectangleEdgeRefsComtrue,
                                        'iffy',
                                        true
                                    )
                                    editClass(
                                        COMTRUEVAR.bottomTextRefComtrue,
                                        'iffy',
                                        true
                                    )
                                    waringTextSettings(
                                        '선명한 촬영을 위해 초점을 맞춰주세요',
                                        'fake_message'
                                    )
                                    waringTextSettings2('bright')
                                }
                            }
                        } else if (
                            data.onnxResponse.message.includes(
                                'detection failed'
                            )
                        ) {
                            // fixme [2025.06.09] 미사용 주석처리
                            // COMTRUECommon.showFakeWarning("", "fake_message");
                            COMTRUEVAR.fakeCount = 0
                            COMTRUEVAR.blurCount = 0
                            waringTextSettings2('focus')
                        }
                    }
                } else {
                    COMTRUEVAR.realCount = 0
                    COMTRUEVAR.fakeCount++
                    if (
                        COMTRUEVAR.fakeCount > COMTRUEVAR.MAX_FAKE_CNT_COMTRUE
                    ) {
                        editClass(
                            COMTRUEVAR.rectangleEdgeRefsComtrue,
                            'warning',
                            true
                        )
                        // cardTypeFakeMessage(cardType)
                        waringTextSettings2('fakeCard')
                    }
                }
                capture(cardType)
                return
            } else if (data.status === -17) {
                // fixme [2025.06.09] 미사용 주석처리
                // COMTRUECommon.showFakeWarning("신분증 종류를 식별 할 수 없습니다.", "fake_message");
                editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'active', true)
                COMTRUEVAR.realCount = 0
                COMTRUEVAR.fakeCount = 0
                COMTRUEVAR.blurCount = 0
                capture(cardType)
                waringTextSettings2('focus')
                return
            } else {
                if ('onnxResponse' in data) {
                    // [2025.06.10] liveness 안에서 real 을 꺼내 확인하는 부분 추가
                    // [2025.06.13] 타입 확인 후 json parse 추가
                    if ('liveness' in data.onnxResponse) {
                        try {
                            if (
                                typeof data.onnxResponse.liveness === 'string'
                            ) {
                                data.onnxResponse.liveness = JSON.parse(
                                    data.onnxResponse.liveness
                                )
                            }
                            if ('real' in data.onnxResponse.liveness) {
                                if (
                                    data.onnxResponse.liveness.real ===
                                        'false' ||
                                    data.onnxResponse.liveness.real === 'F'
                                ) {
                                    COMTRUEVAR.realCount = 0
                                    COMTRUEVAR.fakeCount++
                                    if (
                                        COMTRUEVAR.fakeCount >
                                        COMTRUEVAR.MAX_FAKE_CNT_COMTRUE
                                    ) {
                                        editClass(
                                            COMTRUEVAR.rectangleEdgeRefsComtrue,
                                            'warning',
                                            true
                                        )
                                        // cardTypeFakeMessage(cardType)
                                        waringTextSettings2('fakeCard')
                                    }
                                }
                            }
                        } catch (e) {
                            console.log(
                                'data.onnxResponse.liveness error: ' + e
                            )
                        }
                    }
                    if ('real' in data.onnxResponse) {
                        if (data.onnxResponse.real === 'false') {
                            COMTRUEVAR.realCount = 0
                            COMTRUEVAR.fakeCount++
                            if (
                                COMTRUEVAR.fakeCount >
                                COMTRUEVAR.MAX_FAKE_CNT_COMTRUE
                            ) {
                                editClass(
                                    COMTRUEVAR.rectangleEdgeRefsComtrue,
                                    'warning',
                                    true
                                )
                                // cardTypeFakeMessage(cardType)
                                waringTextSettings2('fakeCard')
                            }
                        }
                    }
                    if ('message' in data.onnxResponse) {
                        if (data.onnxResponse.message.includes('Image blur')) {
                            if (COMTRUEVAR.ocrLiveness === true) {
                                COMTRUEVAR.realCount = 0
                                COMTRUEVAR.blurCount++
                                if (
                                    COMTRUEVAR.blurCount >
                                    COMTRUEVAR.MAX_BLUR_CNT_COMTRUE
                                ) {
                                    editClass(
                                        COMTRUEVAR.rectangleEdgeRefsComtrue,
                                        'iffy',
                                        true
                                    )
                                    editClass(
                                        COMTRUEVAR.bottomTextRefComtrue,
                                        'iffy',
                                        true
                                    )
                                    waringTextSettings(
                                        '밝은 장소에서 촬영해주세요',
                                        'fake_message'
                                    )
                                    waringTextSettings2('focus')
                                }
                            }
                        } else if (
                            data.onnxResponse.message.includes(
                                'detection failed'
                            )
                        ) {
                            // fixme [2025.06.09] 미사용 주석처리
                            // COMTRUECommon.showFakeWarning("", "fake_message");
                            COMTRUEVAR.fakeCount = 0
                            COMTRUEVAR.blurCount = 0
                            waringTextSettings2('focus')
                        }
                    }
                } else {
                    // fixme [2025.06.09] 미사용 주석처리
                    // COMTRUECommon.showFakeWarning("", "fake_message");
                    COMTRUEVAR.fakeCount = 0
                    COMTRUEVAR.blurCount = 0
                    waringTextSettings2('focus')
                }

                if (data.status === -1 || data.status === -3) {
                    editClass(
                        COMTRUEVAR.rectangleEdgeRefsComtrue,
                        'active',
                        true
                    )
                    COMTRUEVAR.realCount = 0
                    waringTextSettings2('focus')
                    //개별 필드인식 (필요필드 읽지 못함)
                } else if (data.status === -6) {
                    editClass(
                        COMTRUEVAR.rectangleEdgeRefsComtrue,
                        'active',
                        true
                    )
                    waringTextSettings2('cutReflect')
                }

                //[25.07.02] 인터벌추가
                // -2 : 신분증 인식 실패(의미 없는 사진인경우)
                if (data.status === -2) {
                    setTimeout(() => {
                        capture(cardType)
                    }, COMTRUEVAR.OCR_INTERVAL)
                    waringTextSettings2('lineGiude')
                } else {
                    capture(cardType)
                    waringTextSettings2('focus')
                }
                return
            }
        },
        []
    )

    const saveCacheImage = useCallback((blob) => {
        const formData = new FormData()
        formData.append('file', blob, { type: 'image/jpeg' })

        fetch(`${COMTRUEVAR.contextPathComtrue}/saveCacheImage`, {
            method: 'PATCH',
            headers: {
                Accept: '*/*',
            },
            body: formData,
        })
            .then((response) => response.json())
            .catch((error) => {
                sendPostMessageClose()
                setTimeout(() => {
                    closeThis('API 서버가 응답하지 않습니다.')
                }, 500)
            })
    }, [])

    const cardTypeFakeMessage = useCallback((cardType) => {
        let message = getKorCardTypeMessage(cardType)
        waringTextSettings(message, 'fake_message', '')
    }, [])

    const waringTextSettings = useCallback((message, divId, gubun) => {
        if (
            COMTRUEVAR.bottomTextRefComtrue &&
            hasClassCheck(COMTRUEVAR.rectangleEdgeRefsComtrue, 'warning')
        ) {
            editClass(COMTRUEVAR.bottomTextRefComtrue, 'iffy', false)
        }

        const messageElement = document.getElementById(divId)
        if (messageElement) {
            messageElement.textContent = message
        }
    }, [])

    const waringTextSettings2 = useCallback((gubun) => {
        const brightElement = document.getElementById('bright')
        const focusElement = document.getElementById('focus')
        const fakeCardElement = document.getElementById('fakeCard')
        const cutReflectElement = document.getElementById('cutReflect')
        const lineGiudedElement = document.getElementById('lineGiude')

        if (gubun === 'bright') {
            if (brightElement) {
                brightElement.style.display = ''
            }
            if (focusElement) {
                focusElement.style.display = 'none'
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = 'none'
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = 'none'
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = 'none'
            }
        } else if (gubun === 'focus') {
            if (brightElement) {
                brightElement.style.display = 'none'
            }
            if (focusElement) {
                focusElement.style.display = ''
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = 'none'
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = 'none'
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = 'none'
            }
        } else if (gubun === 'fakeCard') {
            if (brightElement) {
                brightElement.style.display = 'none'
            }
            if (focusElement) {
                focusElement.style.display = 'none'
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = ''
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = 'none'
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = 'none'
            }
        } else if (gubun === 'cutReflect') {
            if (brightElement) {
                brightElement.style.display = 'none'
            }
            if (focusElement) {
                focusElement.style.display = 'none'
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = 'none'
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = ''
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = 'none'
            }
        } else if (gubun === 'lineGiude') {
            if (brightElement) {
                brightElement.style.display = 'none'
            }
            if (focusElement) {
                focusElement.style.display = 'none'
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = 'none'
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = 'none'
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = ''
            }
        } else {
            if (brightElement) {
                brightElement.style.display = ''
            }
            if (focusElement) {
                focusElement.style.display = 'none'
            }
            if (fakeCardElement) {
                fakeCardElement.style.display = 'none'
            }
            if (cutReflectElement) {
                cutReflectElement.style.display = 'none'
            }
            if (lineGiudedElement) {
                lineGiudedElement.style.display = 'none'
            }
        }
    }, [])

    const closeForDirectInput = useCallback((useWebSocketComtrue) => {
        // FIXME [2025.06.09] COMTRUEWsCommon 미사용 주석처리
        // COMTRUEWsCommon.disconnectWebSocket(useWebSocketComtrue);
        sendPostMessageClose()
        closeThis(null)
    }, [])

    const generalClassifyOnly = useCallback((resultCardType, data) => {
        if (
            resultCardType != null &&
            resultCardType !== data.classifiedCardType
        ) {
            COMTRUEVAR.realCount = 0
            return data.classifiedCardType
        } else {
            if (resultCardType == null && data.classifiedCardType != null) {
                return data.classifiedCardType
            }
            if (COMTRUEVAR.fakeCount < 1 && resultCardType != null) {
                COMTRUEVAR.realCount++
                return resultCardType
            }
        }
    }, [])

    const getKorCardTypeMessage = useCallback((cardType) => {
        let korCardType = ''
        switch (cardType) {
            case 'passport':
            case 'kpassport':
                korCardType = '여권을'
                break
            case 'creditcard':
                korCardType = '신용카드를'
                break
            case 'usim':
                korCardType = '유심카드를'
                break
            case 'imei':
                break
            case 'jumin':
                korCardType = '주민등록증을'
                break
            case 'driver':
                korCardType = '운전면허증을'
                break
            case 'alien':
            case 'foreigner':
                korCardType = '외국인등록증을'
                break
            default:
                korCardType = '신분증을'
                break
        }
        return '실물 ' + korCardType + ' 촬영해주십시오.'
    }, [])

    const base64toFile = useCallback((base_data, filename) => {
        const bstr = window.atob(base_data)
        let array1 = []
        for (let i = 0; i < bstr.length; i++) {
            array1.push(bstr.charCodeAt(i))
        }
        return new Uint8Array(array1)
    }, [])

    const changeCaptureType = useCallback((cardType, captureType) => {
        if (
            captureType != null &&
            captureType !== '' &&
            captureType !== 'NONE'
        ) {
            editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'active', false)
            editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'warning', false)
            editClass(COMTRUEVAR.rectangleEdgeRefsComtrue, 'iffy', false)
            editClass(COMTRUEVAR.bottomTextRefComtrue, 'active', false)
            editClass(COMTRUEVAR.bottomTextRefComtrue, 'warning', false)
            editClass(COMTRUEVAR.bottomTextRefComtrue, 'iffy', false)

            var guideMessage = ''
            switch (cardType.substring(0, cardType.lastIndexOf('back'))) {
                case 'passport':
                case 'kpassport':
                    guideMessage = '여권 '
                    break
                case 'credit':
                    guideMessage = '신용카드 '
                    break
                default:
                    guideMessage = '신분증 '
                    break
            }

            if (cardType.length - 4 === cardType.lastIndexOf('back')) {
                guideMessage = guideMessage + '전면을 '
                cardType = cardType.substring(0, cardType.lastIndexOf('back'))
            } else {
                guideMessage = guideMessage + '후면을 '
                cardType = cardType + 'back'
            }
            guideMessage = guideMessage + '촬영해주세요'

            if (COMTRUEVAR.guideMessageTextRefComtrue) {
                COMTRUEVAR.guideMessageTextRefComtrue.innerText = guideMessage
            }

            if (ComtrueCamera.video.paused) {
                ComtrueCamera.video.play()
            }

            capture(cardType)
            return
        }
    }, [])

    const retryVerify = useCallback((settingJobCount) => {
        // fixme [2025.06.09] 미사용 주석처리
        // COMTRUECommon.modalButtonDisabled();

        fetch(`${COMTRUEVAR.contextPathComtrue}/api/v3/retryVerify`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: COMTRUEVAR.tokenComtrue,
            }),
        })
            .then((response) => response.json())
            .catch((error) => {
                sendPostMessageOcrFail()
                closeThis('초기화에 실패하였습니다.')
            })
    }, [])

    // [2025.06.10] refs.current 의 class 수정
    const editClass = useCallback((elements, className, isAdd) => {
        if (!elements) return
        if (Array.isArray(elements)) {
            elements.forEach((element) => {
                if (isAdd) {
                    element.classList.add(className)
                } else {
                    element.classList.remove(className)
                }
            })
        } else {
            if (isAdd) {
                elements.classList.add(className)
            } else {
                elements.classList.remove(className)
            }
        }
    }, [])

    // [2025.06.10] refs.current 의 특정 class 포함여부 확인
    const hasClassCheck = useCallback((elements, className) => {
        if (!elements) return false
        if (Array.isArray(elements)) {
            return elements.some(
                (element) => element && element.classList.contains(className)
            )
        } else {
            return elements.classList.contains(className)
        }
    })

    return {
        resizeCardFrame,
        videoResize,
        removeAllChild,
        createFakeMessage,
        checkBlob,
        // submitEdit,
        sendEdit,
        cameraStart,
        uint8ArrayToBase64,
        base64ToUint8Array,
        capture,
        uploadResult,
        saveCacheImage,
        cardTypeFakeMessage,
        waringTextSettings,
        closeForDirectInput,
        generalClassifyOnly,
        getKorCardTypeMessage,
        base64toFile,
        changeCaptureType,
        retryVerify,
        blob2,
    }
}

export default useCOMTRUEOcrCommon
